import 'fullpage.js/vendors/scrolloverflow';
import 'fullpage.js/dist/jquery.fullpage';

import { fullpageOptions } from './config';

const afterLoad = () => {
    const IScroll = $('.fp-section.active').find('.fp-scrollable').data('iscrollInstance');
    if (IScroll) {
        IScroll.scrollTo(0, 0, 500);
    }
};

export const fullpageBackHandler = () => {
    // FYI: this is workaround as fullpage library has issues with "back button" and first slide - https://github.com/alvarotrigo/fullPage.js/issues/950
    $(window).on('popstate', function () {
        const hash = window.location.hash;
        if (hash === '' || hash === 'top') {
            if (document.querySelector('.landing-1, .business-1, .personal-1').classList.contains('active')) {
                window.history.go(-1);
            } else {
                $.fn.fullpage.moveTo(1);
            }
        }
    });
};

export const fullpageInit = () => {
    const $fullpage = $('#fullpage');
    if ($fullpage.data('section')) {
        $fullpage.fullpage({
            menu: '#menu',
            anchors: fullpageOptions[$fullpage.data('section')].anchors,
            navigationPosition: 'left',
            showActiveTooltip: true,
            slidesNavigation: true,
            slidesNavPosition: 'bottom',
            scrollOverflow: true,
            responsiveWidth: 768,
            fixedElements: '#header',
            lazyLoading: true,
            afterLoad
        });

        fullpageBackHandler();
    }
};

export const fullpageLoader = () => {
    if (document.getElementById('fullpage')) {
        window.setTimeout(() => {
            $('#preloader').fadeOut(200, () => {
                let preloader = document.getElementById('preloader');

                if (preloader) {
                    preloader.outerHTML = '';
                }
            });
        }, 1000);
    }
};
